module.exports = __webpack_public_path__ + "img/logo_title.aa10ad15.png";